import type { ViewConfigurationPreference } from './types';

export const VIEW_CONFIGURATION_PREFERENCE_KEY =
	'jira.user.deployments.timeline.view.configuration';

export const DEFAULT_VIEW_CONFIGURATION_PREFERENCE: ViewConfigurationPreference = {
	environmentType: {
		production: true,
		staging: true,
		testing: true,
		development: true,
		unmapped: true,
	},
	icons: {
		showIconKey: true,
		showMultipleDeploymentsIcon: true,
	},
	issues: {
		showIssuesWithoutDeployments: false,
	},
};
